import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, ShippingCosts, ShippingCost, } from './types';

const initialState: initState = {
  list: {
    shippingCosts: [],
    count: 0,
  },
  shippingCost: {
    id: 0,
    type: '',
    isAvailable: false,
    openTime: '',
    minimalShippingCost: 0,
    closeTime: '',
    startDate: new Date(),
    endDate: new Date(),
    createdAt: new Date(),
    updatedAt: new Date(),
    RestaurantShippingCost: [],
  },
  available: false,
};

const shippingCostSlice = createSlice({
  name: 'shippingCost',
  initialState,
  reducers: {
    setShippingCostList(state: initState, action: PayloadAction<{ list: ShippingCosts }>) {
      const result = [...action.payload.list.shippingCosts].sort((a, b) => a.id - b.id);
      state.list = { ...action.payload.list, shippingCosts: result, count: action.payload.list.count };
    },
    setShippingCost(state: initState, action: PayloadAction<{ shippingCost: ShippingCost }>) {
      state.shippingCost = action.payload.shippingCost;
    },
    setAvailable(state: initState, action: PayloadAction<{ available: boolean }>) {
      state.available = action.payload.available;
    },
  },
});

export const { setShippingCostList, setShippingCost, setAvailable } = shippingCostSlice.actions;

export default shippingCostSlice.reducer;
